import { Stack, useMediaQuery } from "@mui/material";
import ImageAssets from "../../../../assets";
import { useNavigate } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import styles from "./Screen2.module.css"; // Importing the CSS module

const Screen2 = () => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 839px)");

  return (
    <div className={styles.container}>
      {isMobile && (
        <div className={styles.tabsContainerMobile}>
          <Stack
            columnGap={1}
            alignItems={"center"}
            onClick={() => navigate(-1)}
          >
            <ArrowBackIosNewIcon
              sx={{
                fontSize: "26px",
                color: "var(--secondary-lite-grey-color)",
              }}
            />
          </Stack>
        </div>
      )}
      <img
        src={ImageAssets.ig_screen2_01}
        alt="Group7"
        style={{
          width: "100%",
          height: "20rem",
          objectFit: "contain",
        }}
      />
      <p className={styles.textBig}>What do you get on Sekeron? </p>
      <p className={styles.textSmall}>
        Sekeron is absolutely free to use and does not take money/copyright from
        your collaborations. Your collaborations are completely yours!
      </p>

      <Segment2
        heading="Create Posts"
        text="Upload audio, video, photos, and text to showcase your skills"
        image={ImageAssets.ig_01}
      />
      <Segment2
        heading="Explore and Discover"
        text="Find projects, and artists. Use filters to find what inspires you"
        image={ImageAssets.ig_02}
        alt
      />
      <Segment2
        heading="Create or Join Projects"
        text="Reduces misunderstandings while collaborating"
        image={ImageAssets.ig_03}
      />
      <Segment2
        heading="The Collab Space"
        text="Access tools to create together and protect your copyright"
        image={ImageAssets.ig_04}
        alt
      />
      <Segment2
        heading="Connect & Grow"
        text="Find like-minded artists within the artist community"
        image={ImageAssets.ig_screen2_06}
      />
    </div>
  );
};

const Segment2 = ({ heading, text, image, alt = false }) => {
  const isMobile = useMediaQuery("(max-width: 839px)");

  return (
    <div className={`${styles.segment} ${alt ? styles.reverse : ""}`}>
      <img src={image} alt="" className={styles.image} />
      <div className={styles.textContainer}>
        <p className={styles.segmentHead}>{heading}</p>
        <p
          className={styles.segmentTxt}
          style={{ fontSize: "1.4rem", lineHeight: isMobile ? "" : "1.8rem" }}
        >
          {text}
        </p>
      </div>
    </div>
  );
};

export default Screen2;
